module.exports = __webpack_public_path__ + "img/case16-中国东方航空.0ee938fc.png";